import { useEffect } from 'react';

// Hooks
import useStories from '@/utils/hooks/swr/useStories';
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';

import PropTypes from 'prop-types';

//Lib
import { STORY } from '@/lib/posts/postTypes';
import { INSTAGRAM } from '@/lib/socialProfile';

import SelectStoriesType from '@/components/pages/myprofile/filters/SelectStoriesType';
// Components
import PostsTab from '@/components/pages/myprofile/PostsTab';

const StoriesInstagramTab = ({
    isFiltersOpen,
    toggleFilters,
    isExportModalOpen,
    toggleExportModal,
    header
}) => {
    const { activeSocialProfile } = useActiveSocialProfile();

    const {
        dataStories,
        requestParams,
        isLoadMore,
        // Loaders
        isLoadingMore,
        isLoadingInitialData,
        // Functions
        mutateStories,
        setRequestParams,
        loadMoreStories
    } = useStories({
        activeSPID: activeSocialProfile?.id
    });

    useEffect(() => {
        setRequestParams((prevState) => ({
            ...prevState,
            with_labels: true,
            with_albums: true
        }));
    }, [setRequestParams]);

    return (
        <PostsTab
            isFiltersOpen={isFiltersOpen}
            toggleFilters={toggleFilters}
            isExportModalOpen={isExportModalOpen}
            toggleExportModal={toggleExportModal}
            activeSocialProfile={activeSocialProfile?.social_network_type ?? INSTAGRAM}
            dataMedias={dataStories}
            isLoadMore={isLoadMore}
            isLoadingMore={isLoadingMore}
            isLoadingInitialData={isLoadingInitialData}
            requestParams={requestParams}
            setRequestParams={setRequestParams}
            mutateMedias={mutateStories}
            loadMoreMedia={loadMoreStories}
            header={header}
            postFormat={STORY}
            postType={STORY}
            exportType={STORY}
            customFilters={
                <div className="mt-4 w-full md:ml-3 md:mt-0 md:flex-1 lg:w-52 lg:flex-none">
                    <SelectStoriesType setRequestParams={setRequestParams} />
                </div>
            }
        />
    );
};

StoriesInstagramTab.propTypes = {
    isFiltersOpen: PropTypes.bool,
    toggleFilters: PropTypes.func,
    isExportModalOpen: PropTypes.bool,
    toggleExportModal: PropTypes.func,
    header: PropTypes.node
};

export default StoriesInstagramTab;
